import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import '@vidstack/react/player/styles/base.css';
import '@vidstack/react/player/styles/plyr/theme.css';

import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { PlyrLayout, plyrLayoutIcons } from '@vidstack/react/player/layouts/plyr';

export function RunbookMedia (){
    return (
        <MediaPlayer title="Callgoose SQIBS Runbook Automation" src={'https://resources.callgoose.com/cdn/sys/video/callgoose_sqibs_runbook_automation.mp4'}>
            <MediaProvider />
            <PlyrLayout icons={plyrLayoutIcons} />
        </MediaPlayer>
    )
}
;

export function  ProcessMedia () {
    return (
        <MediaPlayer title="Callgoose SQIBS Process Automation" src={'https://resources.callgoose.com/cdn/sys/video/callgoose_sqibs_process_automation.mp4'}>
            <MediaProvider />
            <PlyrLayout icons={plyrLayoutIcons} />
        </MediaPlayer>
    )
}

export default function AlertDialog({open,setOpen, children}) {

    const handleClose = () => {
        setOpen(null);
    };

    return (
        <React.Fragment>
            <Dialog
                open={open!=null}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='lg'
            >
                <DialogContent>
                {children}
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}
